import React from "react";
import Paragraph from "./Paragraph";
import { useState, useEffect } from "react";

const FooterComponent = ({ text }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Example: 768px as the mobile breakpoint
    };

    checkScreenSize(); // Check screen size on initial render

    window.addEventListener("resize", checkScreenSize); // Add event listener

    return () => window.removeEventListener("resize", checkScreenSize); // Clean up event listener
  }, []);

  return (
    <div id="footer" className="footer-container">
      <div className="footer-text-container">
        <Paragraph text={text} />
        <div className="divider-box">
          <p>SAY HI:</p>
          <div className="insta-container">
            <p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/abhishekkapahi/"
              >
                @abhishekkapahi
              </a>
            </p>
            <p>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/shrenisanghvi/"
              >
                @shrenisanghvi
              </a>
            </p>
          </div>
        </div>
        {isMobile && (
          <div className="footer-img-container">
            <img src="https://i.ibb.co/ykP37v2/footer-mobile.png" alt="cat" />
          </div>
        )}
      </div>
      <style jsx>{`
        .footer-container {
          padding: 2em 0em;
          width: 100%;
          background-image: url("https://i.postimg.cc/C10vtmdX/banner-1.png\");
          background-position: top;
          background-repeat: no-repeat;
          height: 100vh;
        }

        .footer-text-container {
          color: white;
          margin: auto;
          padding: 2em;
        }

        .footer-img-container {
          max-width: 100%;
        }

        .footer-img-container img {
          max-width: 100%;
        }

        @media (max-width: 768px) {
          .footer-container {
            height: auto;
            background-image: none;
          }
        }

        .insta-container {
          margin: 20px 0px;
        }

        .insta-container p {
          margin: 2px 0px;
        }

        .footer-container p {
          font: 100 22px Clash Display, -apple-system, Roboto, Helvetica,
            sans-serif;
          text-align: start;
          font-size: 1.6em;
        }
        .footer-container a {
          color: white;
        }
        .divider-box {
          border-top: 0.1px solid #767676;
          width: 100%;
          display: flex;
          gap: 20px;
        }
      `}</style>
    </div>
  );
};

export default FooterComponent;
